import { FC } from 'react';
import './style.scss';

export const GPTQuestion: FC<{ question: string }> = ({ question }) => {
  return <h1 className="gpt-question">{question}</h1>;
};
